import React, { useState } from "react";
import { Navigate } from "react-router-dom";
import { useStores } from "../hooks";
import { useMount } from "react-use";
import Header from "../component/Header";
import Footer from "../component/Footer";

const Debug = () => {
  const { sessionStore } = useStores();
  const [completed, setCompleted] = useState<boolean>(false);

  useMount(() => {
    sessionStore.debug = true;
    setCompleted(true);
  });

  return (
    <>
      {completed && <Navigate to="/" />}
      <div className="page-set">
        <Header />
        <div className="Main gologin">
          <section className="keyin">
            <p>Debug...</p>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Debug;
